import { createContext, useContext } from "react";

import { FlowApp } from "./services/app";
import { IUserInfo } from "./services/permission";

export type PageConfigContextType = {
  mode: "app" | "plugin" | "template";
  defaultValue?: FlowApp;
  loading?: boolean;
  header?: React.ReactNode;
  /** 在 C 端环境下 */
  isInConsumerEnv?: boolean;
  /** 用于控制编排权限 */
  userInfo?: IUserInfo;
};

export const PageConfigContext = createContext<PageConfigContextType>({
  mode: "app",
  isInConsumerEnv: false,
});

export const usePageConfig = () => useContext(PageConfigContext);
